import { AnyAction, Reducer } from 'redux';
import {
  ACTION, RequestLoadSubscriptions, ReceiveLoadSubscriptions, FailLoadSubscriptions,
  RequestSaveSubscriptions, ReceiveSaveSubscriptions, FailSubscriptionsExecute,
  RequestLoadSubscriptionOptions, ReceiveLoadSubscriptionOptions,
  RequestLoadResponsibleForUnit, ReceiveLoadResponsibleForUnit, FailLoadResponsibleForUnit,
  RequestLoadAlerts, ReceiveLoadAlerts, FailLoadAlerts
} from './action-types';
import { SubscriptionsState } from './types';

export const INITIAL_SUBSCRIPTIONS_STATE: SubscriptionsState = {
  subscriptions: undefined,
  subscriptionOptions: undefined,
  responsibleForUnit: undefined,
  alerts: undefined,
  fetchingLoadSubscriptions: false,
  fetchingSubscriptionOptions: false,
  fetchingSaveSubscriptions: false,
  fetchingLoadResponsibleForUnit: false,
  fetchingLoadAlerts: false,
  validation: {}
};

export const reducers: { [indexer: string]: Reducer<SubscriptionsState> } = {

  [ACTION.REQUEST_LOAD_SUBSCRIPTIONS]: (state: SubscriptionsState, action: RequestLoadSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadSubscriptions: true,
      subscriptions: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_SUBSCRIPTIONS]: (state: SubscriptionsState, action: ReceiveLoadSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadSubscriptions: false,
      subscriptions: action.data
    };
  },

  [ACTION.FAIL_LOAD_SUBSCRIPTIONS]: (state: SubscriptionsState, action: FailLoadSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadSubscriptions: false
    };
  },

  [ACTION.REQUEST_LOAD_SUBSCRIPTION_OPTIONS]: (state: SubscriptionsState, action: RequestLoadSubscriptionOptions): SubscriptionsState => {
    return {
      ...state,
      fetchingSubscriptionOptions: true,
      subscriptionOptions: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_SUBSCRIPTION_OPTIONS]: (state: SubscriptionsState, action: ReceiveLoadSubscriptionOptions): SubscriptionsState => {
    return {
      ...state,
      fetchingSubscriptionOptions: false,
      subscriptionOptions: action.data
    };
  },

  [ACTION.FAIL_LOAD_SUBSCRIPTION_OPTIONS]: (state: SubscriptionsState, action: FailLoadSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingSubscriptionOptions: false
    };
  },

  [ACTION.REQUEST_SAVE_SUBSCRIPTIONS]: (state: SubscriptionsState, action: RequestSaveSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingSaveSubscriptions: true
    };
  },

  [ACTION.RECEIVE_SAVE_SUBSCRIPTIONS]: (state: SubscriptionsState, action: ReceiveSaveSubscriptions): SubscriptionsState => {
    return {
      ...state,
      fetchingSaveSubscriptions: false
    };
  },

  [ACTION.FAIL_DEFAULT_SUBSCRIPTIONS]: (state: SubscriptionsState, action: FailSubscriptionsExecute): SubscriptionsState => {
    return {
      ...state,
      fetchingSaveSubscriptions: false
    };
  },

  [ACTION.REQUEST_LOAD_RESPONSIBLE_FOR_UNIT]: (state: SubscriptionsState, action: RequestLoadResponsibleForUnit): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadResponsibleForUnit: true,
      responsibleForUnit: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_RESPONSIBLE_FOR_UNIT]: (state: SubscriptionsState, action: ReceiveLoadResponsibleForUnit): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadResponsibleForUnit: false,
      responsibleForUnit: action.data
    };
  },

  [ACTION.FAIL_LOAD_RESPONSIBLE_FOR_UNIT]: (state: SubscriptionsState, action: FailLoadResponsibleForUnit): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadResponsibleForUnit: false
    };
  },

  [ACTION.REQUEST_LOAD_ALERTS]: (state: SubscriptionsState, action: RequestLoadAlerts): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadAlerts: true,
      alerts: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_ALERTS]: (state: SubscriptionsState, action: ReceiveLoadAlerts): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadAlerts: false,
      alerts: action.data
    };
  },

  [ACTION.FAIL_LOAD_ALERTS]: (state: SubscriptionsState, action: FailLoadAlerts): SubscriptionsState => {
    return {
      ...state,
      fetchingLoadAlerts: false
    };
  }
};

export const reducer: Reducer<SubscriptionsState> =
  (state: SubscriptionsState = INITIAL_SUBSCRIPTIONS_STATE, action: AnyAction) => {
    const r = reducers[action.type];
    return (r && r(state, action)) || state;
  };
